import { AccessType } from '../models/authorization';
import { PrivilegesAccessType } from '../interfaces/common/privilegesAccessTypeData';

/**
 * Helper service for conversion between old and new permission models
 * Enables gradual migration without breaking existing code
 */
export class AccessTypeMapper {
  /**
   * Converts legacy access type to new format
   */
  static fromLegacy(legacyType: PrivilegesAccessType | string | null): AccessType {
    switch (legacyType) {
      case PrivilegesAccessType.RW:
      case 'RW':
      case 'Full':
      case 'Write':
        return AccessType.Write;
      case PrivilegesAccessType.R:
      case 'R':
      case 'Read':
        return AccessType.Read;
      case PrivilegesAccessType.NoAccess:
      case 'No Access':
      case null:
      default:
        return AccessType.None;
    }
  }
}
